import {
	apiClient,
	getAuthHeaders,
	handleServiceError,
} from 'api/config/config';

// Auth Services
export const authService = {
	// --- SESSION --- //
	login: async (email, password, recaptchaToken) => {
		try {
			return await apiClient.post('client/auth/login', {
				username: email,
				password: password,
				recaptchaToken: recaptchaToken,
			});
		} catch (error) {
			handleServiceError(error);
		}
	},
	signUp: async (user, token) => {
		try {
			return await apiClient.post('client/auth/register', {
				username: user.email,
				email: user.email,
				password: user.password,
				referralCode: user.referralCode,
				firstName: user.firstName,
				lastName: user.lastName,
				recaptchaToken: token,
			});
		} catch (error) {
			handleServiceError(error);
		}
	},

	// --- PASSWORD --- //
	verifyPassword: async (token, userId, password) => {
		try {
			return await apiClient.post(
				'client/auth/verify-password',
				{
					userId,
					password,
				},
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
	changePassword: async (token, userId, oldPassword, newPassword) => {
		try {
			return await apiClient.post(
				'client/auth/change-password',
				{
					userId,
					oldPassword,
					newPassword,
				},
				getAuthHeaders(token)
			);
		} catch (error) {
			handleServiceError(error);
		}
	},
	forgotPassword: async (email) => {
		try {
			return await apiClient.post('client/auth/forgot-password', { email });
		} catch (error) {
			handleServiceError(error);
		}
	},
	resetPassword: async (code, newPassword) => {
		try {
			return await apiClient.put('client/auth/reset-password', {
				code,
				newPassword,
			});
		} catch (error) {
			handleServiceError(error);
		}
	},
	validateOtp: async (otp) => {
		try {
			return await apiClient.post('client/auth/validate-otp', { otp });
		} catch (error) {
			handleServiceError(error);
		}
	},

	// --- EMAIL --- //
	confirmEmail: async (token) => {
		try {
			return await apiClient.get('client/auth/confirm-email', {
				params: { token },
			});
		} catch (error) {
			handleServiceError(error);
		}
	},
	resendConfirmationEmail: async (email, recaptchaToken) => {
		try {
			return await apiClient.post('client/auth/resend-confirmation-email', {
				email,
				recaptchaToken,
			});
		} catch (error) {
			handleServiceError(error);
		}
	},
	unsubscribeEmail: async (token) => {
		try {
			return await apiClient.get('client/auth/unsubscribe-email', {
				params: { token },
			});
		} catch (error) {
			handleServiceError(error);
		}
	},

	// --- WITHDRAWAL --- //
	confirmWithdrawal: async (token) => {
		try {
			return await apiClient.get('client/auth/confirm-withdrawal', {
				params: { token },
			});
		} catch (error) {
			handleServiceError(error);
		}
	},
};
